import { ReactNode } from "react";
import { styled } from "styled-components";
import { Layout } from "antd";

const { Content } = Layout;

const LayoutContent = ({ children }: { children: ReactNode }) => {
  return (
    <StyledLayoutContent>
      <Content>{children}</Content>
    </StyledLayoutContent>
  );
};
export default LayoutContent;
const StyledLayoutContent = styled.div`
  // height: calc(100vh - 90px);
  // min-height: calc(100vh - 80px);
  overflow-x: hidden;
  overflow-y: auto;
  background: #eff1fd;
  .ant-layout-content {
    // min-height: calc(100vh - 100px);
    min-height: calc(100vh - 80px);
    position: relative;
    border-radius: 20px 40px 40px 40px;
    background: #fff;
    margin: 0px 10px 10px 10px;
  }
`;
